import { BasicsClass } from "@/common/BasicsClass";

export class WithdrawVerifyBillAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['list', {
      url: '/admin/allin/transferList',
      name: 'list',
      label: '列表'
    }],
  ])
  public getList(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {


    const apiUrls = this.apiUrls

    const url = apiUrls.get('list').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

}
